import React, { Component } from "react"
import { graphql } from "gatsby"
import "components/FlexibleContent/AcfFlexibleContent"
import Layout from "components/Layout/Layout"
import FlexibleContent from "components/FlexibleContent/FlexibleContent"
import ContainerMax from "components/shared/ContainerMax"
import HeroCarousel from "components/Blocks/HeroCarousel"
import EventCarousel from "components/Blocks/EventCarousel/EventCarousel"
import HomeBgImage from "components/shared/HomeBgImage"

class HomeTemplate extends Component {

    render() {
        const data = this.props.data.wordpressPage

        return (
            <Layout data={data}>
                <ContainerMax noPadding>
                    <HeroCarousel data={data.acf.hero_carousel} />
                    <EventCarousel />
                </ContainerMax>
                
                <HomeBgImage>
                    <FlexibleContent data={data} />
                </HomeBgImage>
            </Layout>
        )
    }
}

export default HomeTemplate

export const query = graphql`
query($id: String!) {
    wordpressPage(id: { eq: $id }) {
        id
        lang
        template
        title
        acf {
            hero_carousel {
                image_landscape {
                    localFile {
                        childImageSharp {
                            fluid(maxWidth: 1600, quality: 100)  {
                                ...GatsbyImageSharpFluid_withWebp_noBase64
                            }
                        }
                    }
                }
                image_portrait {
                    localFile {
                        childImageSharp {
                            fluid(maxWidth: 768, quality: 100)  {
                                ...GatsbyImageSharpFluid_withWebp_noBase64
                            }
                        }
                    }
                }
                title
                sub_title
                description
                link_1 {
                    title
                    url
                    target
                }
                link_2 {
                    title
                    url
                    target
                }
            }
            blocks_page {
                ...AcfFlexibleContent
            }
        }
    }
}
`